import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ServicesAPI from "../../services/services";
import useResponse from "../../hooks/useResponse";
import { googleEvent_LOJ210 } from "../../lib/google-analytics";
import { setStepperDisable } from "../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";
import { useNavigate } from "react-router-dom";
import { clevertap_Re_kyc_failed, clevertap_Re_kyc_success } from "../../lib/clevertap-events";

export default function DigilockerVerify() {
  const dispatch = useDispatch();
  const { handleStep } = useResponse();
  const { accountId } = useSelector((state) => state.user);

  const navigate = useNavigate();

  useEffect(() => {
    const handleAadhaarVerificationDigilocker = async () => {
      dispatch(setStepperDisable(false));

      try {
        const params = {};
        const urlParams = new URLSearchParams(window.location.search);

        const { aadhaarVerificationWebhookDigilocker, aadhaarPANVerify } = new ServicesAPI();

        urlParams.forEach((value, key) => {
          params[key] = value;
        });

        const res = await aadhaarVerificationWebhookDigilocker(params);

        if (localStorage.getItem("reKyc") === "1") {
          await clevertap_Re_kyc_success({
            option: "digilocker",
          });
          navigate("/loan-approval");
          return;
        }

        if (res) {
          const res = await aadhaarPANVerify(accountId);

          if (res && res.statusCode === 200) {
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: "Verified Successfully",
              showConfirmButton: false,
              allowOutsideClick: false,
              timer: 2000,
            });
            setTimeout(async () => {
              await handleStep();
              handlehideContextualLoader();
            }, 2000);
          } else {
            Swal.fire({
              text: res.message,
              icon: "error",
              confirmButtonText: "OK",
            }).then((result) => {
              if (result?.isConfirmed) {
                window.location.href = res.data.route || "/dashboard";
              }
              handlehideContextualLoader();
            });
            googleEvent_LOJ210();
          }
        } else {
          await handleStep();
          handlehideContextualLoader();
        }
      } catch (error) {
        console.log("Error:", error);

        if (localStorage.getItem("reKyc") === "1") {
          await clevertap_Re_kyc_failed({
            option: "digilocker",
          });
        }
      } finally {
        handlehideContextualLoader();
      }
    };

    handleAadhaarVerificationDigilocker();
  }, []);

  return <div>{handleShowContextualLoader("Aadhar verification in progress...")}</div>;
}
